import React, { useState, useRef } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { height, width } from '@fortawesome/free-solid-svg-icons/fa0';

const Vaniyar = () => {
  const [formData, setFormData] = useState({
    register: '', name: '', dob: '', religion: '', otherCaste: '', education: '', job: '', income: '',
    marriageStatus: 'முதல் திருமணம்', height: '', color: '', blood: '',
    fitness: 'நல்ல நிலை', motherTongue: '', fatherName: '', fatherJob: '',
    motherName: '', motherJob: '', brothers: '', sisters: '', assets: '',
    native: '', gothram: '', address: '', date: '',
    birthTime: '', birthPlace: '', birthDay: '', tamilMonthYear: '',
    lagnam: '', rasi: '', nakshatram: '', dosham: '',
    dasaBalance: '', dasaYear: '', dasaMonth: '', dasaDays: '',otherCaste: '',todayDate: '',gender: 'ஆண்',birthTime: '',birthHour: '12',
  birthMin: '00',
 
  birthPeriod: 'AM',birthPlace: '',job: '',income: '',motherTongue: 'தமிழ்', // Default
  otherMotherTongue: '',address: '',
  mobile: '',fatherName: '',
  isFatherAlive: 'ஆம்',
  fatherJob: '',
  motherName: '',
  isMotherAlive: 'ஆம்',
  motherJob: '',
  totalSiblings: '1',
  elderBrothers: '0',
  elderSisters: '0',
  youngerBrothers: '0',
  youngerSisters: '0',nativePlace: '',
  assetsDetails: '',
  registrationDate: new Date().toISOString().split('T')[0], // Automatically sets today
  });

const planets = ["", "ல", "சூரி", "சந்", "செவ்", "ராகு", "சனி", "புதன்", "குரு", "கேது", "சுக்", "(வ)", "மாந்"];  const [rasiChart, setRasiChart] = useState(Array(12).fill(""));
  const [amsamChart, setAmsamChart] = useState(Array(12).fill(""));
  const [photo, setPhoto] = useState(null);
  const printRef = useRef();
const heightOptions = [
  "4ft-121cm", "4ft 1in-124cm", "4ft 2in-127cm", "4ft 3in-130cm", "4ft 4in-132cm", 
  "4ft 5in-134cm", "4ft 6in-137cm", "4ft 7in-140cm", "4ft 8in-142cm", "4ft 9in-145cm", 
  "4ft 10in-147cm", "4ft 11in-150cm", "5ft-152cm", "5ft 1in-155cm", "5ft 2in-157cm", 
  "5ft 3in-160cm", "5ft 4in-163cm", "5ft 5in-165cm", "5ft 6in-168cm", "5ft 7in-170cm", 
  "5ft 8in-173cm", "5ft 9in-175cm", "5ft 10in-178cm", "5ft 11in-180cm", "6ft-183cm", 
  "6ft 1in-185cm", "6ft 2in-188cm", "6ft 3in-191cm", "6ft 4in-193cm", "6ft 5in-196cm", 
  "6ft 6in-198cm", "6ft 7in-201cm", "6ft 8in-203cm", "6ft 9in-206cm", "6ft 10in-208cm", 
  "6ft 11in-211cm", "7ft-213cm"
];
const formatTimeAMPM = (time) => {
  if (!time) return '';
  let [hours, minutes] = time.split(':');
  let ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // Convert 0 to 12
  return `${hours}:${minutes} ${ampm}`;
};
 
  const handleChartChange = (index, value, type) => {
    const newChart = type === 'rasi' ? [...rasiChart] : [...amsamChart];
    newChart[index] = value;
    type === 'rasi' ? setRasiChart(newChart) : setAmsamChart(newChart);
  };

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPhoto(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const downloadPDF = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element, { scale: 3, useCORS: true });
    const data = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    pdf.addImage(data, 'PNG', 0, 0, 210, 297);
    pdf.save(`${formData.name || 'BioData'}.pdf`);
  };
const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};
const educationOptions = [
  "B.E. Civil Engineering", "B.E. Environmental Engineering", "B.E. Geoinformatics Engineering",
  "B.E. Agriculture Engineering", "B.E. Aeronautical Engineering", "B.E. Automobile Engineering",
  "B.E. Mechanical Engineering", "B.E. Materials Science and Engineering", "B.E. Manufacturing Engineering",
  "B.E. Production Engineering", "B.E. Industrial Engineering", "B.E. Industrial Engineering and Management",
  "B.E. Marine Engineering", "B.E. Mechatronics Engineering", "B.E. Mechanical and Automation Engineering",
  "B.E. Robotics and Automation", "B.E. Mechanical Engineering (Sandwich)", "B.E. Aerospace Engineering",
  "B.E. Electrical and Electronics Engineering", "B.E. Electronics and Instrumentation Engineering",
  "B.E. Instrumentation and Control Engineering", "B.E. Electronics and Communication Engineering",
  "B.E. Computer Science and Engineering", "B.Tech. Information Technology", "B.E. Biomedical Engineering",
  "B.E. Medical Electronics", "B.E. Computer and Communication Engineering", "B.E. Electronics and Telecommunication Engineering",
  "B.Tech. Chemical Engineering", "B.Tech. Chemical and Electrochemical Engineering", "B.Tech. Petroleum Engineering",
  "B.Tech. Petrochemical Technology", "B.E. Petrochemical Engineering", "B.Tech. Biotechnology",
  "B.Tech. Pharmaceutical Technology", "B.Tech. Food Technology", "B.Tech. Polymer Technology",
  "B.Tech. Plastics Technology", "B.Tech.Textile Technology", "B.Tech. Fashion Technology",
  "B.Tech. Textile Chemistry", "B.Tech. Handloom and Textile Technology", "B. Arch.",
  "B.Sc. Mathematics", "B.Sc. Mathematics with CA", "B.Sc. Applied Mathematics", "B.Sc. Statistics",
  "B.Sc. Physics", "B.Sc. Physics with Material Science", "B.Sc. Physics with Nano-Technology",
  "B.Sc. Physics with C.A.", "B.Sc. Plant Biology and Plant Biotechnology / B.Sc. Botany", "B.Sc. Chemistry",
  "B.Sc. Chemistry with Nanotechnology", "B.Sc. Industrial Chemistry", "B.Sc. Biochemistry",
  "B.Sc. Biochemistry with Nanotechnology", "B.Sc. Pharmaceutical Chemistry", "B.Sc. Polymer Technology",
  "B.C.A.", "B.Sc. Computer Science", "B.Sc. Computer Science and Applications", "B.Sc. Information Technology",
  "B.Sc. Software Systems", "B.Sc. Computer Technology", "B.Sc. Multimedia & Web Technology",
  "B.Sc. Clinical Laboratory Technology", "B.Sc. Electronics", "B.Sc. Electronics & Communication System",
  "B.Sc. Biotechnology", "B.Sc. Interior Design", "B.Sc. Interior Design with Computer Applications",
  "B.Sc. Microbiology", "B.Sc. Microbiology with Nanotechnology", "B.Sc. Geography",
  "B.Sc. Advanced Zoology and Biotech with Sericulture", "B.Sc. Advanced Zoology and Biotechnology / B.Sc. Zoology",
  "B.Sc. Zoology (Wildlife Biology)", "B.Sc. Costume Design and Fashion - Vocational", "B.Sc. Costume Design and Fashion",
  "B.Sc. Apparel Fashion Designing", "B.Sc. Apparel Manufacturing Merchandising", "B.Sc. Fashion Apparel Management",
  "B.Sc. Garment Production Processing / Garment Designing & Production", "B.Sc. Nutrition & Dietetics",
  "B.Sc. Food Science & Nutrition / B.Sc. Food Science & Nutrition with CA", "B.Sc. Catering Science & Hotel Management",
  "B.Sc. Visual Communication & Electronic Media", "B.B.A.", "B.B.A. with C.A.", "B.B.A. International Business",
  "B.B.A. Retail Management", "B.B.A. Service Management", "B.B.A. Information Systems",
  "B.B.A. Information Management", "B.B.A. Banking", "B.B.A. Insurance", "B.B.A. Marketing Management",
  "B.B.A. Financial Management", "B.B.A. Investment", "Certificate Course in Mushroom Cultivation",
  "Certificate Course in Wheat Grass Production", "Certificate Course in Exotic Vegetables and Aromatics",
  "Diploma in Medical Laboratory Technology (DMLT)", "Diploma in Patient Care (Nursing)",
  "Diploma in X-Ray and Imaging Technology", "Diploma in Physician Assistant", "Diploma in Anesthesia Technology",
  "Diploma in Operation Theatre Technology", "Diploma in Accident and Emergency Technology",
  "Diploma in Critical Care Management", "B.Com.", "B.Com. C.A.", "B.Com. E-Commerce", "B.Com. Corporate Secretaryship",
  "B.Com. Corporate Secretaryship with C.A.", "B.Com. Retail Marketing", "B.Com. Information Technology",
  "B.Com. Banking & Insurance", "B.Com. Co-operation", "B.Com. Co-operative Management",
  "B.Com – PA ( Professional Accounting )", "B.Com – with Diploma in Cooperative Management",
  "B.Com Co-Operative Management", "B.Com International Business", "B.Com - Finance",
  "B.Com. Garment Cost Accounting", "B.A. Tamil Literature", "B.A. English Language & Literature",
  "B.A. English Literature with Computer Applications", "B.A. History", "B.A. History and Tourism",
  "B.A. History with Civil Services", "B.A. Tourism and Travel Management", "B.A. Economics",
  "B.A. Economics with Portfolio Management", "B.A. Economics with Logistics & Freight Management",
  "B.A. Economics with Insurance & Finance", "B.A. Economics with Computer Application",
  "B.A. Economics with Global Business", "B.A. Economics with Retailing", "B.A. Defence and Strategic Studies",
  "Others"
];
const colorOptions = [
  "சிவப்பு",
  "மிகவும் சிவப்பு",
  "மாநிறம்",
  "குறைந்த மாநிறம்",
  "கருப்பு"
];
  const renderHoroscopeGrid = (data, type, deityImg) => {
    const gridLayout = [
        0, 1, 2, 3, 
        11, 'merged', 'merged', 4, 
        10, 'merged', 'merged', 5, 
        9, 8, 7, 6
    ];

    return (
     <div style={gridContainer}>
      {gridLayout.map((cell, i) => {
        if (cell === 'merged') {
          if (i === 5) { 
            return <div key={i} style={mergedCenterTop}><img src={deityImg} alt="deity" style={deityStyle} /></div>;
          }
          if (i === 9) { 
            return <div key={i} style={mergedCenterBottom}>{type === 'rasi' ? 'இராசி' : 'அம்சம்'}</div>;
          }
          return null;
        }
        return (
          <div key={i} style={gridCell}>
            {/* பிரிண்டிங்கில் தெரிய வேண்டிய உரை */}
            <div style={{ whiteSpace: 'pre-wrap', textAlign: 'center' }}>
              {data[cell]}
            </div>
          </div>
        );
      })}
    </div>
  );
};

  return (
    <div style={{ padding: '20px', backgroundColor: '#f0f0f0', minHeight: '100vh', fontFamily: "'Noto Sans Tamil', Latha, sans-serif" }}>
      
      {/* 1. INPUT FORM SECTION */}
      <div style={formCardStyle}>
        <h2 style={{ textAlign: 'center', color: '#e91e63', marginBottom: '20px' }}>தமிழ் மணமாலை - முழு விவரங்கள் பதிவு</h2>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px' }}> 
          <input style={inputStyle} name="register" placeholder="பதிவு எண்" onChange={handleChange} />
          <input style={inputStyle} name="name" placeholder="வரன் பெயர்" onChange={handleChange} />
    <select 
  name="religion" 
  style={inputStyle} 
  value={formData.religion} // 1. Added value prop
  onChange={handleChange}     // 2. Added onChange handler
>
  <option value="">மதம் / சாதி தேர்ந்தெடுக்கவும்</option>
  <option value="முதலியார்">முதலியார்</option>
  <option value="செங்குந்தர் முதலியார்">செங்குந்தர் முதலியார்</option>
  <option value="வன்னியர்">வன்னியர்</option>
  <option value="ஆதி திராவிடர்">ஆதி திராவிடர்</option>
  <option value="தேவர்">தேவர்</option>
  <option value="பிள்ளை">பிள்ளை</option>
  <option value="மீனவர்">மீனவர்</option>
  <option value="உடையார்">உடையார்</option>
  <option value="கொங்கு வெள்ளாளக் கவுண்டர்">கொங்கு வெள்ளாளக் கவுண்டர்</option>
  <option value="நாடார்">நாடார்</option>
  <option value="செட்டியார்">செட்டியார்</option>
  <option value="கார்னியர்">கார்னியர்</option>
  <option value="குரும்ப கவுண்டர்">குரும்ப கவுண்டர்</option>
  <option value="அருந்ததியர்">அருந்ததியர்</option>
  <option value="மூப்பனார்">மூப்பனார்</option>
  <option value="யாதவர்">யாதவர்</option>
  <option value="பள்ளர்">பள்ளர்</option>
  <option value="வள்ளுவன்">வள்ளுவன்</option>
  <option value="ரெட்டியார்">ரெட்டியார்</option>
  <option value="விஸ்வகர்மா">விஸ்வகர்மா</option>
  <option value="மருத்துவர்">மருத்துவர்</option>
  <option value="வண்ணார்">வண்ணார்</option>
  <option value="வீரசைவ ஜங்கம்">வீரசைவ ஜங்கம்</option>
  <option value="அகமுடைய முதலியார்">அகமுடைய முதலியார்</option>
  <option value="வீரசைவம்">வீரசைவம்</option>
  <option value="நாயுடு">நாயுடு</option>
  <option value="நாயக்கர்">நாயக்கர்</option>
  <option value="வெள்ளாளர்">வெள்ளாளர்</option>
  <option value="ஐயங்கார்">ஐயங்கார்</option>
  <option value="பிராமின்">பிராமின்</option>
  <option value="தேவேந்திர குல வெள்ளாளர்">தேவேந்திர குல வெள்ளாளர்</option>
  <option value="முத்தரையர்">முத்தரையர்</option>
  <option value="சோழிய வெள்ளாளர்">சோழிய வெள்ளாளர்</option>
  <option value="முத்துராஜா">முத்துராஜா</option>
  <option value="இசை வேளாளர்">இசை வேளாளர்</option>
  <option value="ஐயர்">ஐயர்</option>
  <option value="Others">Others</option>
  {/* உடன்பிறந்தோர் விவரங்கள் */}
</select>
{/* உடன்பிறந்தோர் விவரங்கள் */}
<div style={{ gridColumn: 'span 4', border: '1px solid #ddd', padding: '15px', borderRadius: '8px', marginTop: '10px' }}>
  <label style={{ fontSize: '14px', color: '#e91e63', fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>
    உடன்பிறந்தோர் விவரங்கள்:
  </label>
  
  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px' }}>
    {/* மொத்த உடன்பிறந்தோர் */}
    <div>
      <label style={{ fontSize: '12px' }}>மொத்த எண்ணிக்கை (வரனுடன்):</label>
      <select name="totalSiblings" style={inputStyle} onChange={handleChange}>
        {Array.from({length: 10}, (_, i) => <option key={i+1} value={i+1}>{i+1}</option>)}
      </select>
    </div>

    {/* அண்ணன் */}
    <div>
      <label style={{ fontSize: '12px' }}>அண்ணன்:</label>
      <select name="elderBrothers" style={inputStyle} onChange={handleChange}>
        {Array.from({length: 11}, (_, i) => <option key={i} value={i}>{i}</option>)}
      </select>
    </div>

    {/* அக்கா */}
    <div>
      <label style={{ fontSize: '12px' }}>அக்கா:</label>
      <select name="elderSisters" style={inputStyle} onChange={handleChange}>
        {Array.from({length: 11}, (_, i) => <option key={i} value={i}>{i}</option>)}
      </select>
    </div>

    {/* தம்பி */}
    <div>
      <label style={{ fontSize: '12px' }}>தம்பி:</label>
      <select name="youngerBrothers" style={inputStyle} onChange={handleChange}>
        {Array.from({length: 11}, (_, i) => <option key={i} value={i}>{i}</option>)}
      </select>
    </div>

    {/* தங்கை (தேவைப்பட்டால்) */}
    <div>
      <label style={{ fontSize: '12px' }}>தங்கை:</label>
      <select name="youngerSisters" style={inputStyle} onChange={handleChange}>
        {Array.from({length: 11}, (_, i) => <option key={i} value={i}>{i}</option>)}
      </select>
    </div>
  </div>
</div>
{/* தந்தை விவரங்கள் */}
<div style={{ gridColumn: 'span 2', border: '1px solid #ddd', padding: '10px', borderRadius: '8px' }}>
  <label style={{ fontSize: '13px', color: '#e91e63', fontWeight: 'bold' }}>தந்தை விவரம்:</label>
  <input style={{...inputStyle, marginTop: '5px'}} name="fatherName" placeholder="தந்தை பெயர்" onChange={handleChange} />
  
  <div style={{ display: 'flex', gap: '15px', margin: '10px 0', fontSize: '14px' }}>
    <span>தந்தை இருக்கின்றாரா?</span>
    <label><input type="radio" name="isFatherAlive" value="ஆம்" checked={formData.isFatherAlive === 'ஆம்'} onChange={handleChange} /> ஆம்</label>
    <label><input type="radio" name="isFatherAlive" value="இல்லை" checked={formData.isFatherAlive === 'இல்லை'} onChange={handleChange} /> இல்லை</label>
  </div>
  
  <input style={inputStyle} name="fatherJob" placeholder="தந்தையின் தொழில்" onChange={handleChange} />
</div>

{/* தாய் விவரங்கள் */}
<div style={{ gridColumn: 'span 2', border: '1px solid #ddd', padding: '10px', borderRadius: '8px' }}>
  <label style={{ fontSize: '13px', color: '#e91e63', fontWeight: 'bold' }}>தாய் விவரம்:</label>
  <input style={{...inputStyle, marginTop: '5px'}} name="motherName" placeholder="தாய் பெயர்" onChange={handleChange} />
  
  <div style={{ display: 'flex', gap: '15px', margin: '10px 0', fontSize: '14px' }}>
    <span>தாய் இருக்கின்றாரா?</span>
    <label><input type="radio" name="isMotherAlive" value="ஆம்" checked={formData.isMotherAlive === 'ஆம்'} onChange={handleChange} /> ஆம்</label>
    <label><input type="radio" name="isMotherAlive" value="இல்லை" checked={formData.isMotherAlive === 'இல்லை'} onChange={handleChange} /> இல்லை</label>
  </div>
  
  <input style={inputStyle} name="motherJob" placeholder="தாயின் தொழில்" onChange={handleChange} />
</div>

          <input style={inputStyle} name="education" placeholder="படிப்பு/வேலை" onChange={handleChange} />
          <input style={inputStyle} name="job" placeholder="வருமானம்" onChange={handleChange} />
          <input style={inputStyle} name="income" placeholder="" onChange={handleChange} />
          <select 
  name="gender" 
  style={inputStyle} 
  value={formData.gender} 
  onChange={handleChange}
>
  <option value="ஆண்">ஆண்</option>
  <option value="பெண்">பெண்</option>
</select>
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
  <label style={{ fontSize: '13px', color: '#e91e63', fontWeight: 'bold' }}>வருமானம் (Monthly Income):</label>
  <input 
    type="text"
    style={inputStyle} 
    name="income" 
    placeholder="உதாரணம்: ₹50,000 / மாதம்" 
    value={formData.income}
    onChange={handleChange} 
  />
</div>
 <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
  <label style={{ fontSize: '13px', color: '#e91e63', fontWeight: 'bold' }}>பதிவு தேதி (Reg. Date):</label>
  <input 
    type="date" 
    style={inputStyle} 
    name="registrationDate" 
    value={formData.registrationDate}
    onChange={handleChange} 
  />
</div>
<select 
  style={inputStyle} 
  name="height" 
  onChange={handleChange}
  defaultValue=""
>
  <option value="" disabled>உயரம் தேர்ந்தெடுக்கவும்</option>
  {heightOptions.map((option) => (
    <option key={option} value={option}>
      {option}
    </option>
  ))}
</select>        
<select 
  style={inputStyle} 
  name="color" 
  onChange={handleChange}
  defaultValue=""
>
  
  <option value="" disabled>நிறம் தேர்ந்தெடுக்கவும்</option>
  {colorOptions.map((color) => (
    <option key={color} value={color}>
      {color}
    </option>
  ))}
</select>
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
  <label style={{ fontSize: '13px', color: '#e91e63', fontWeight: 'bold' }}>தாய் மொழி (Mother Tongue):</label>
  <select 
    style={inputStyle} 
    name="motherTongue" 
    value={formData.motherTongue} 
    onChange={handleChange}
  >
    <option value="தமிழ்">தமிழ்</option>
    <option value="தெலுங்கு">தெலுங்கு</option>
    <option value="கன்னடம்">கன்னடம்</option>
    <option value="உருது">உருது</option>
    <option value="Others">Others</option>
  </select>

  {/* Show this only if Others is selected */}
  {formData.motherTongue === 'Others' && (
    <input 
      style={{ ...inputStyle, marginTop: '5px' }} 
      name="otherMotherTongue" 
      placeholder="உங்கள் மொழியை டைப் செய்யவும்" 
      onChange={handleChange} 
    />
  )}
</div>
{/* சொந்த ஊர் மற்றும் சொத்து விவரங்கள் */}
<div style={{ gridColumn: 'span 4', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginTop: '10px' }}>
  
  {/* சொந்த ஊர் மற்றும் மாவட்டம் */}
  <div style={{ gridColumn: 'span 4' }}>
    <label style={{ fontSize: '14px', fontWeight: 'bold' }}>சொந்த ஊர் மற்றும் மாவட்டம்:</label>
    <input 
      style={{ ...inputStyle, marginTop: '5px' }} 
      name="nativePlace" 
      placeholder="உதாரணம்: சேலம், சேலம் மாவட்டம்" 
      onChange={handleChange} 
    />
  </div>

  {/* சொத்து விபரம் - பெரிய டெக்ஸ்ட் ஏரியா */}
  <div style={{ gridColumn: 'span 4' }}>
    <label style={{ fontSize: '14px', fontWeight: 'bold' }}>சொத்து விபரம்:</label>
    <textarea 
      style={{ 
        ...inputStyle, 
        marginTop: '5px', 
        height: '120px', // பெட்டியின் உயரம் பெரியதாக இருக்க
        resize: 'vertical' 
      }} 
      name="assetsDetails" 
      placeholder="வீடு, நிலம் மற்றும் இதர சொத்து விவரங்களை இங்கே விரிவாக எழுதவும்..." 
      onChange={handleChange} 
    />
  </div>
</div>
<input 
  type="date" 
  style={inputStyle} 
  name="todayDate" 
  placeholder="பிறந்த தேதி"
  onChange={handleChange} 
/>     
          <select style={inputStyle} name="fitness" onChange={handleChange} value={formData.fitness}>
            <option value="நல்ல நிலை">நல்ல நிலை</option>
            <option value="குறைபாடு">குறைபாடு</option>
          </select>
          

          <select style={inputStyle} name="marriageStatus" onChange={handleChange} value={formData.marriageStatus}>
            <option value="முதல் திருமணம்">முதல் திருமணம்</option>
            <option value="மறுமணம்">மறுமணம்</option>
          </select>
<div style={{ gridColumn: 'span 2', display: 'flex', flexDirection: 'column', gap: '5px' }}>
  <label style={{ fontSize: '13px', color: '#e91e63', fontWeight: 'bold' }}>பிறந்த நேரம் (Time of Birth):</label>
  <div style={{ display: 'flex', gap: '5px' }}>
    {/* Hours */}
    <select name="birthHour" style={inputStyle} onChange={handleChange} value={formData.birthHour}>
      {Array.from({ length: 12 }, (_, i) => i + 1).map(h => (
        <option key={h} value={h < 10 ? `0${h}` : h}>{h < 10 ? `0${h}` : h}</option>
      ))}
    </select>

    {/* Minutes */}
    <select name="birthMin" style={inputStyle} onChange={handleChange} value={formData.birthMin}>
      {Array.from({ length: 60 }, (_, i) => i).map(m => (
        <option key={m} value={m < 10 ? `0${m}` : m}>{m < 10 ? `0${m}` : m}</option>
      ))}
    </select>

    {/* Seconds */}


    {/* AM/PM */}
    <select name="birthPeriod" style={inputStyle} onChange={handleChange} value={formData.birthPeriod}>
      <option value="AM">AM</option>
      <option value="PM">PM</option>
    </select>

  </div>
</div>
<div style={{ gridColumn: 'span 4', display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px' }}>
  <label style={{ fontSize: '13px', color: '#e91e63', fontWeight: 'bold' }}>முகவரி & தொடர்பு விவரங்கள்:</label>
  
  {/* Long Address Bar */}
  <textarea 
    style={{ ...inputStyle, height: '60px', resize: 'vertical' }} 
    name="address" 
    placeholder="முழு முகவரி (Door No, Street, Area, City, Pincode)" 
    onChange={handleChange} 
  />

  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
    <input 
      style={inputStyle} 
      name="mobile" 
      placeholder="கைபேசி எண் (Mobile Number)" 
      onChange={handleChange} 
    />
    <input 
      style={inputStyle} 
      name="whatsapp" 
      placeholder="வாட்ஸ்அப் எண் (WhatsApp Number)" 
      onChange={handleChange} 
    />
  </div>
</div>
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
  <label style={{ fontSize: '13px', color: '#e91e63', fontWeight: 'bold' }}>படிப்பு (Education):</label>
  <select 
    style={inputStyle} 
    name="education" 
    value={formData.education} 
    onChange={handleChange}
  >
    <option value="">தேர்ந்தெடுக்கவும்</option>
    {educationOptions.map((opt) => (
      <option key={opt} value={opt}>{opt}</option>
    ))}
  </select>

  {/* Show this text input ONLY if "Others" is selected */}
  {formData.education === 'Others' && (
    <input 
      style={{ ...inputStyle, marginTop: '5px' }} 
      name="otherEducation" 
      placeholder="உங்கள் படிப்பை டைப் செய்யவும்" 
      onChange={handleChange} 
    />
  )}
</div>
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
  <label style={{ fontSize: '13px', color: '#e91e63', fontWeight: 'bold' }}>வேலை (Occupation):</label>
  <input 
    type="text"
    style={inputStyle} 
    name="job" 
    placeholder="உதாரணம்: மென்பொருள் பொறியாளர்" 
    value={formData.job}
    onChange={handleChange} 
  />
</div>
   <input 
  style={inputStyle} 
  name="birthPlace" 
  placeholder="பிறந்த இடம்" 
  value={formData.birthPlace}
  onChange={handleChange} 
/>
          <input style={inputStyle} name="date" placeholder="தேதி" onChange={handleChange} />
          <input type="file" accept="image/*" onChange={handlePhotoUpload} style={inputStyle} />
          
          <input style={horoInputStyle} name="birthTime" placeholder="நேரம்" onChange={handleChange} />
          <input style={horoInputStyle} name="birthPlace" placeholder="இடம்" onChange={handleChange} />
          <input style={horoInputStyle} name="birthDay" placeholder="கிழமை" onChange={handleChange} />
          <input style={horoInputStyle} name="tamilMonthYear" placeholder="தமிழ் மாதம்" onChange={handleChange} />
          
          <input style={inputStyle} name="dasaBalance" placeholder="திசா இருப்பு" onChange={handleChange} />
          <input style={inputStyle} name="dasaYear" placeholder="வருடம்" onChange={handleChange} />
          <input style={inputStyle} name="dasaMonth" placeholder="மாதம்" onChange={handleChange} />
          <input style={inputStyle} name="dasaDays" placeholder="நாட்கள்" onChange={handleChange} />
        </div>
<div style={chartInputContainer}>
  {/* இராசி உள்ளீடு */}
 <div style={{ flex: 1 }}>
    <p style={{ color: '#00AEEF', fontWeight: 'bold' }}>இராசி கட்டம் (1-12):</p>
    <div style={dropdownGrid}>
      {rasiChart.map((val, i) => (
        <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          {/* டைப் செய்யும் வசதி */}
          <input 
            type="text"
            placeholder={i + 1}
            value={val}
            onChange={(e) => handleChartChange(i, e.target.value, 'rasi')} 
            style={{ ...inputStyle, padding: '2px', fontSize: '11px', textAlign: 'center' }} 
          />
          {/* கிரகத்தைத் தேர்வு செய்யும் Dropdown */}
          <select 
            style={{ fontSize: '10px', padding: '1px', border: '1px solid #00AEEF', borderRadius: '3px' }}
            onChange={(e) => {
              const currentVal = rasiChart[i];
              const newVal = currentVal ? `${currentVal}, ${e.target.value}` : e.target.value;
              handleChartChange(i, newVal, 'rasi');
            }}
          >
            <option value="">சேர்</option>
            {planets.filter(p => p !== "").map(p => <option key={p} value={p}>{p}</option>)}
          </select>
        </div>
      ))}
    </div>
  </div>

  {/* அம்சம் உள்ளீடு */}
 <div style={{ flex: 1 }}>
    <p style={{ color: '#00AEEF', fontWeight: 'bold' }}>அம்சம் கட்டம் (1-12):</p>
    <div style={dropdownGrid}>
      {amsamChart.map((val, i) => (
        <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <input 
            type="text"
            placeholder={i + 1}
            value={val}
            onChange={(e) => handleChartChange(i, e.target.value, 'amsam')} 
            style={{ ...inputStyle, padding: '2px', fontSize: '11px', textAlign: 'center' }} 
          />
          <select 
            style={{ fontSize: '10px', padding: '1px', border: '1px solid #00AEEF', borderRadius: '3px' }}
            onChange={(e) => {
              const currentVal = amsamChart[i];
              const newVal = currentVal ? `${currentVal}, ${e.target.value}` : e.target.value;
              handleChartChange(i, newVal, 'amsam');
            }}
          >
            <option value="">சேர்</option>
            {planets.filter(p => p !== "").map(p => <option key={p} value={p}>{p}</option>)}
          </select>
        </div>
      ))}
    </div>
    </div>

  {/* கிரகங்களின் பட்டியல் - Hidden DataList */}
  <datalist id="planet-list">
    {planets.map((p, idx) => (
      <option key={idx} value={p} />
    ))}
  </datalist>
</div>
        <textarea style={{ ...inputStyle, gridColumn: 'span 4', marginTop: '15px' }} name="address" placeholder="முகவரி" onChange={handleChange} />
        <button onClick={downloadPDF} style={btnStyle}>PDF ஆக பதிவிறக்கம் செய்க</button>
      </div>

      {/* 2. PDF PREVIEW SECTION */}
<div ref={printRef} style={pdfContainerStyle}>
         <div style={{ marginTop: '-10px', padding: '0 3px',position: 'relative', zIndex: '2'}}>
  <img 
    src="/header-logo.png" 
    alt="Header" 
    style={{ width: '100%', display: 'block' }} 
  />
</div>

        <div style={{ display: 'flex', padding: '0 40px', gap: '20px' }}>
          <div style={{ flex: 1 }}>
            <DataRow label="பதிவு எண்" value={formData.register} />
            <DataRow label="வரன் பெயர்" value={formData.name} />
<DataRow 
  label="பிறந்த தேதி" 
  value={
    formData.todayDate 
      ? formData.todayDate.split('-').reverse().join('-') 
      : ''
  } 
/>

<DataRow label="வேலை" value={formData.job} />
<DataRow label="வருமானம்" value={formData.income} />
<DataRow
  label="மதம் / சாதி"
  value={
    formData.religion === 'Others'
      ? formData.otherCaste
      : formData.religion
  }
/>


            <DataRow label="படிப்பு" value={formData.education} />
          <div style={rowStyle}>
  <span style={labelStyle}>
    திருமண நிலை <span style={colonStyle}>:</span>
  </span>
  <div style={{ flex: 1, display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
    <span style={pinkCheck}>{formData.marriageStatus === 'முதல் திருமணம்' ? '☑' : '☐'}</span> 
    <span style={{ marginLeft: '5px', fontSize: '15px' }}>முதல் திருமணம் /</span> 
    
    <span style={{ ...pinkCheck, marginLeft: '15px' }}>{formData.marriageStatus === 'மறுமணம்' ? '☑' : '☐'}</span> 
    <span style={{ marginLeft: '5px', fontSize: '15px' }}>மறுமணம்</span>
  </div>
</div>
          </div>
<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '160px' }}>
  
  {/* பதிவு தேதி வரி */}
  <div style={{ display: 'flex', width: '100%', alignItems: 'flex-end', marginBottom: '8px', fontSize: '15px' }}>
    <span style={{ color: '#00AEEF', fontWeight: 'bold', whiteSpace: 'nowrap', minWidth: '85px' }}>பதிவு தேதி</span>
    <span style={{ color: '#00AEEF', fontWeight: 'bold', margin: '0 10px',marginLeft:'10px' }}>:</span>
    <span style={{ flex: 1, borderBottom: '1.5px solid #00AEEF', textAlign: 'center', whiteSpace: 'nowrap' }}>
      {formData.registrationDate ? formData.registrationDate.split('-').reverse().join('-') : ''}
    </span>
  </div>

  {/* பாலினம் வரி */}
  <div style={{ display: 'flex', width: '100%', alignItems: 'flex-end', marginBottom: '10px', fontSize: '15px' }}>
    <span style={{ color: '#00AEEF', fontWeight: 'bold', whiteSpace: 'nowrap', minWidth: '85px' }}>பாலினம்</span>
    <span style={{ color: '#00AEEF', fontWeight: 'bold', margin: '0 5px' }}>:</span>
    <span style={{ flex: 1, borderBottom: '1.5px solid #00AEEF', textAlign: 'center', whiteSpace: 'nowrap' }}>
      {formData.gender}
    </span>
  </div>

  {/* புகைப்படப் பெட்டி */}
 <div style={{
    width: '160px',                // பெட்டியின் அகலம்
    height: '250px',               // உயரத்தை அதிகரித்துள்ளேன் (A4-க்கு ஏற்ற அளவு)
    border: '1.5px solid #e91e63', // இளஞ்சிவப்பு நிற பார்டர்
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fafafa',
    borderRadius: '4px',
    overflow: 'hidden',
    marginLeft:'10px'   
              // படம் பெட்டியை விட்டு வெளியே வராமல் தடுக்க
}}>
    {photo ? (
        <img 
            src={photo} 
            alt="P" 
            style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: 'cover', // படம் பெட்டியை முழுமையாக நிரப்ப (Cover) உதவும்
                display: 'block'
            }} 
        />
    ) : (
        <span style={{ fontSize: '14px', color: '#ccc', fontWeight: 'bold' }}>PHOTO</span>
    )}
</div>
</div>
        </div>

        <div style={{ padding: '5px 40px' }}>
        <div style={{ 
    
    marginTop: '-115px',     // Pulls the entire row upward to remove large gaps
    lineHeight: '1.2'       // Decreases the vertical space between the text and line
}}>
  <div style={rowStyle}>
    {/* Height Section */}
    <span style={labelStyle}>உயரம் <span style={colonStyle}>:</span></span> 
    <span style={{ 
        borderBottom: '1.5px solid #00AEEF', 
        width: '120px', 
        fontSize: '18px', 
        marginRight:'10px',
        display: 'inline-block'
    }}>
      {formData.height}
    </span>
    
    {/* Color Section */}
    <span style={labelStyle}>நிறம் <span style={colonStyle}>:</span></span> 
    <span style={{ 
        borderBottom: '1.5px solid #00AEEF', 
        width: '120px', 
        fontSize: '13px', 
        marginRight:'5px',
        paddingLeft: '5px',
        display: 'inline-block'
    }}>
      {formData.color}
    </span>
  </div>
</div>
            <div style={rowStyle}>
              <span style={labelStyle}>உடற்தகுதி :</span>
              <span style={pinkCheck}>{formData.fitness === 'நல்ல நிலை' ? '☑' : '☐'}</span> நல்ல நிலை / 
              <span style={{ ...pinkCheck, marginLeft: '10px' }}>{formData.fitness === 'குறைபாடு' ? '☑' : '☐'}</span> குறைபாடு
            </div>
         <div style={{ padding: '0px', marginTop: '10px', display: 'flex', alignItems: 'flex-end' }}>
  <span style={{ 
    color: '#00AEEF', 
    fontWeight: 'bold', 
    fontSize: '13px', 
    width: '95px', 
    display: 'flex', 
    
  }}>
    தாய் மொழி <span style={{ marginLeft: 'auto' }}>:</span>
  </span>
  
  <span style={{ 
    borderBottom: '1.5px solid #00AEEF', // Blue solid line
    width: '100px',                     // Reduced width to make the line shorter
    fontSize: '13px', 
    paddingLeft: '10px',
   
  }}>
    {formData.motherTongue === 'Others' ? formData.otherMotherTongue : formData.motherTongue}
  </span>
</div>
{/* Address Row */}
<div style={{ padding: '0', marginTop: '10px', display: 'flex', alignItems: 'flex-start' }}>
  <span style={{ 
    color: '#00AEEF', 
    fontWeight: 'bold', 
    fontSize: '13px', 
    width: '95px', 
    display: 'flex', 
    justifyContent: 'space-between',
    marginTop: '2px' 
  }}>
    முகவரி <span style={{ marginLeft: 'auto' }}>:</span>
  </span>
  
  <span style={{ 
    borderBottom: '1.5px solid #00AEEF', // நீல நிற திடமான கோடு
    width: '400px',                     // கோட்டின் நீளத்தைக் குறைக்க (Adjust width here)
    fontSize: '13px', 
    paddingLeft: '10px',
    marginLeft: '5px',
    lineHeight: '1.4',
    textAlign: 'left',
    minHeight: '20px'
  }}>
    {formData.address}
  </span>
</div>
{/* Contact Numbers Row with Icons */}
<div style={rowStyle}>
  <span style={labelStyle}>தொடர்பு எண் <span style={colonStyle}>:</span></span>
  <div style={{ ...valStyle, display: 'flex', gap: '20px', alignItems: 'center', borderBottom: 'none' }}>
    {/* Mobile Icon & Number */}
    <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
      <span style={{ color: '#00AEEF', fontSize: '14px' }}>📞</span> 
      <span style={{ borderBottom: '1px solid #00AEEF' }}>{formData.mobile}</span>
    </span>

    {/* WhatsApp Icon & Number */}
    <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
      <span style={{ color: '#25D366', fontSize: '14px' }}>💬</span> 
      <span style={{ borderBottom: '1px solid #00AEEF' }}>{formData.whatsapp}</span>
    </span>
  </div>
</div>
        </div>
{/* PDF Preview - Family Details Row */}
{/* தந்தை மற்றும் தாய் விவரங்கள் - Single Line Layout */}
<div style={{ display: 'flex', flexWrap: 'wrap', padding: '0 40px', marginTop: '-12px' }}>
  
  {/* தந்தை பெயர் */}
  <div style={{ width: '50%', display: 'flex', alignItems: 'flex-end', marginBottom: '2px' }}>
    <span style={{ color: '#00AEEF', fontWeight: 'bold', fontSize: '13px', width: '95px', display: 'flex', justifyContent: 'space-between', whiteSpace: 'nowrap' }}>
      தந்தை பெயர் <span style={{ }}>:</span>
    </span>
    <span style={{ 
        borderBottom: '1.5px solid #00AEEF', 
        width: '160px', 
        fontSize: '13px', 
        paddingLeft: '5px', 
        marginLeft: '15px',
        whiteSpace: 'nowrap',  // Prevents text from wrapping
        overflow: 'hidden',    // Hides any text that exceeds width
        textOverflow: 'ellipsis' // Adds "..." if text is too long
    }}>
      {formData.fatherName} ({formData.isFatherAlive})
    </span>
  </div>

  {/* தந்தை தொழில் */}
  <div style={{ width: '50%', display: 'flex', alignItems: 'flex-end', marginBottom: '2px' }}>
    <span style={{ color: '#00AEEF', fontWeight: 'bold', fontSize: '13px', width: '95px', display: 'flex', justifyContent: 'space-between', whiteSpace: 'nowrap' }}>
      பணி <span style={{ marginLeft: 'auto' }}>:</span>
    </span>
    <span style={{ 
        borderBottom: '1.5px solid #00AEEF', 
        width: '160px', 
        fontSize: '13px', 
        paddingLeft: '5px', 
        marginLeft: '5px',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }}>
      {formData.fatherJob}
    </span>
  </div>

  {/* தாய் பெயர் */}
  <div style={{ width: '50%', display: 'flex', alignItems: 'flex-end', marginBottom: '2px' }}>
    <span style={{ color: '#00AEEF', fontWeight: 'bold', fontSize: '13px', width: '95px', display: 'flex', justifyContent: 'space-between', whiteSpace: 'nowrap' }}>
      தாய் பெயர் <span style={{ marginLeft: 'auto' }}>:</span>
    </span>
    <span style={{ 
        borderBottom: '1.5px solid #00AEEF', 
        width: '160px', 
        fontSize: '13px', 
        paddingLeft: '5px', 
        marginLeft: '5px',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }}>
      {formData.motherName} ({formData.isMotherAlive})
    </span>
  </div>

  {/* தாய் தொழில் */}
  <div style={{ width: '50%', display: 'flex', alignItems: 'flex-end', marginBottom: '2px' }}>
    <span style={{ color: '#00AEEF', fontWeight: 'bold', fontSize: '13px', width: '95px', display: 'flex', justifyContent: 'space-between', whiteSpace: 'nowrap' }}>
      பணி <span style={{ marginLeft: 'auto' }}>:</span>
    </span>
    <span style={{ 
        borderBottom: '1.5px solid #00AEEF', 
        width: '160px', 
        fontSize: '13px', 
        paddingLeft: '5px', 
        marginLeft: '5px',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }}>
      {formData.motherJob}
    </span>
  </div>
</div>
{/* PDF Preview - Siblings Row */}
<div style={{ padding: '0 40px', marginTop: '-10px', display: 'flex', alignItems: 'flex-end' }}>
  {/* லேபிள் (Label) */}
  <span style={{ 
    color: '#00AEEF', 
    fontWeight: 'bold', 
    fontSize: '13px', 
    width: '95px', 
    display: 'flex', 
    justifyContent: 'space-between',
    whiteSpace: 'nowrap' 
    
  }}>
    உடன்பிறந்தோர் <span style={{  }}>:</span>
  </span>

  {/* விவரங்கள் - மார்ஜின் சேர்க்கப்பட்டுள்ளது */}
  <span style={{ 
    borderBottom: '1.5px solid #00AEEF', 
    width: '450px',         // கோட்டின் நீளம் குறைக்கப்பட்டுள்ளது
    fontSize: '13px', 
    marginLeft: '40px',     // லேபிளில் இருந்து தள்ளி இருக்க இடைவெளி (Fixes Overlap)
    paddingLeft: '5px',     // கோட்டின் தொடக்கத்தில் சிறிய இடைவெளி
    whiteSpace: 'nowrap',   // ஒரே வரியில் இருக்க
    overflow: 'hidden', 
    textOverflow: 'ellipsis',
    color: '#000',
    marginTop:'10px',
  }}>
    மொத்தம் {formData.totalSiblings} - 
    {formData.elderBrothers > 0 && ` அண்ணன்(${formData.elderBrothers})`}
    {formData.elderSisters > 0 && ` அக்கா(${formData.elderSisters})`}
    {formData.youngerBrothers > 0 && ` தம்பி(${formData.youngerBrothers})`}
    {formData.youngerSisters > 0 && ` தங்கை(${formData.youngerSisters})`}
    {formData.elderBrothers == 0 && formData.elderSisters == 0 && formData.youngerBrothers == 0 && formData.youngerSisters == 0 && " இல்லை"}
  </span>
</div>
{/* PDF Preview - Native and Assets */}
<div style={{ padding: '0 35px', marginTop: '5px' }}>
  
  {/* சொந்த ஊர் DataRow */}
  <DataRow label="சொந்த ஊர்" value={formData.nativePlace} />

  {/* சொத்து விபரம் - அதிக வரிகள் வர வாய்ப்புள்ளதால் */}
  <div style={{ display: 'flex', marginTop: '4px', alignItems: 'flex-start' }}>
    <span style={{ 
      color: '#00AEEF', 
      fontWeight: 'bold', 
      fontSize: '12px', 
      width: '90px', 
      display: 'flex', 
      justifyContent: 'space-between' 
    }}>
      சொத்து விபரம் <span style={{ marginLeft: 'auto' }}>:</span>
    </span>
    <span style={{ 
      borderBottom: '1px solid #00AEEF', 
      flex: 1, 
      fontSize: '12px', 
      paddingLeft: '5px', 
      minHeight: '40px', // அதிக இடம் வழங்க
      lineHeight: '1.4',
      textAlign: 'justify'
    }}>
      {formData.assetsDetails}
    </span>
  </div>
</div>
        <div style={roseDividerStyle}></div>

        <div style={blueBoxContainer}>
          <div style={blueSubBox}>
            <SubDataRow label="பிறந்த நேரம்" value={formData.birthTime} />
            <SubDataRow label="பிறந்த இடம்" value={formData.birthPlace} />
            <SubDataRow label="பிறந்த கிழமை" value={formData.birthDay} />
          </div>
          <div style={{ width: '2px', backgroundColor: '#e91e63', height: '60px', margin: '0 10px' }}></div>
          <div style={blueSubBox}>
            <SubDataRow label="இராசி" value={formData.rasi} />
            <SubDataRow label="நட்சத்திரம்" value={formData.nakshatram} />
            <SubDataRow label="தமிழ் மாதம்" value={formData.tamilMonthYear} />
          </div>
        </div>

        <div style={roseDividerStyle}></div>

        {/* UPDATED CHARTS SECTION WITH CENTER IMAGE */}
        <div style={horoscopeSectionWrapper}>
          {renderHoroscopeGrid(rasiChart, 'rasi', '/lord1.jpg')} 
          
          <div style={centerImageContainer}>
              <img src="/new43.png" alt="Center Logo" style={centerLogoStyle} />
          </div>

          {renderHoroscopeGrid(amsamChart, 'amsam', '/lord2.png')}
        </div>
<div style={{ padding: '0 40px', marginTop: '10px' }}>
  {/* Dasa Section */}
  <div style={dasaRowStyle}>
    ஜென்ன கால திசா இருப்பு : <span style={dasaInputLine}>{formData.dasaBalance}</span>
    வருடம் : <span style={smallInputLine}>{formData.dasaYear}</span>
    மாதம் : <span style={smallInputLine}>{formData.dasaMonth}</span>
    நாட்கள் : <span style={smallInputLine}>{formData.dasaDays}</span>
  </div>

  {/* Dashed Pink Divider */}
  <div style={roseDividerStyle}></div>

  {/* Terms and Conditions - Justified */}
  <div style={termsContainerStyle}>
    <span style={termsLabelStyle}>விதிமுறைகள் & நிபந்தனைகள் :</span> 
    தங்களுக்குப் பிடித்தமான வரனைத் தங்களது விருப்பத்தின் பேரில் தாங்களே பேசி முடிவு செய்துகொள்ளலாம். 
    திருமணம் நிச்சயிக்கப்பட்டவுடன் கட்டாயம் எங்களுக்குத் தெரியப்படுத்தவேண்டும். வேறு எந்தக் 
    கட்டணமும் செலுத்தத் தேவையில்லை. தாங்கள் தரும் விபரங்கள் தவறாக இருக்கும் பட்சத்தில் 
    அதற்குத் தாங்களே பொறுப்பு.
  </div>
</div>
      </div>
    </div>
  );
};
const DataRow = ({ label, value }) => (
  <div style={rowStyle}>
    <span style={labelStyle}>
      {label} <span style={colonStyle}>:</span>
    </span>
    <span style={valStyle}>{value}</span>
  </div>
);
// --- PDF Components & Styles ---

const SubDataRow = ({ label, value }) => (
  <div style={{ display: 'flex', marginBottom: '5px', fontSize: '13px' }}>
    <span style={{ color: '#00AEEF', fontWeight: 'bold', minWidth: '90px' }}>{label} :</span>
    <span style={{ borderBottom: '1px dotted #00bcd4', flex: 1 }}>{value}</span>
  </div>
);
// --- CORE A4 CONTAINER ---
const pdfContainerStyle = { 
  width: '210mm', 
  height: '297mm', 
  backgroundColor: '#fff', 
  margin: 'auto', 
  boxSizing: 'border-box', 
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  border: '2px solid #00AEEF', // பிரதான பார்டர்
  padding: '1px', // உள் கோட்டிற்கு இடைவெளி
};
const topDesignStyle = {
  position: 'absolute',
  top: '0',
  right: '0',
  width: '45%', // மேல் வலதுபுறம் உள்ள நீல நிறக் கோடு
  height: '20px',
  borderBottom: '2px solid #00AEEF',
  borderLeft: '2px solid #00AEEF',
  backgroundColor: '#fff',
  zIndex: 10
};

// பார்டருக்கு உள்ளே இருக்கும் மெல்லிய கோடு (Inner Border)
const innerBorderStyle = {
  position: 'absolute',
  top: '5px',
  left: '5px',
  right: '5px',
  bottom: '5px',
  pointerEvents: 'none',
  zIndex: 5
};
// --- FLEX GRID DATA LAYOUT ---
const rowStyle = { 
  marginBottom: '4px', // Tight spacing for A4 fit
  display: 'flex', 
  alignItems: 'flex-end', 
  paddingRight: '8px' 
};

const labelStyle = { 
  color: '#00AEEF', 
  fontWeight: 'bold', 
  fontSize: '12px', 
  width: '95px', // Fixed label width for perfect vertical alignment
  display: 'flex', 
  justifyContent: 'space-between',
  marginRight: '5px'
};

const valStyle = { 
  borderBottom: '1.2px solid #00AEEF', 
  flex: 1, 
  fontSize: '12px', 
  paddingLeft: '5px', 
  minHeight: '16px',
  color: '#000'
};

const halfValStyle = { 
  borderBottom: '1px dotted #000', 
  flex: 1, 
  marginRight: '10px', 
  fontSize: '12px',
  paddingLeft: '5px'
};

const colonStyle = { 
  marginLeft: 'auto' 
};

// --- PHOTO BOX ---
const photoBoxStyle = { 
  width: '115px', 
  height: '140px', 
  border: '1.5px solid #e91e63', 
  display: 'flex', 
  alignItems: 'center', 
  justifyContent: 'center',
  backgroundColor: '#fafafa',
  borderRadius: '4px'
};

const photoImg = { 
  width: '100%', 
  height: '100%', 
  objectFit: 'cover' 
};

// --- DECORATIVE ELEMENTS ---
const pinkCheck = { 
  color: '#e91e63', 
  fontSize: '16px', 
  fontWeight: 'bold' 
};

const roseDividerStyle = { 
  borderTop: '1.5px dashed #e91e63', 
  margin: '8px 45px',
  width: 'calc(100% - 90px)'
};

// --- HOROSCOPE (JATHAGAM) GRID ---


const gridContainer = { 
  display: 'grid', 
  gridTemplateColumns: 'repeat(4, 45px)', 
  gridTemplateRows: 'repeat(4, 45px)', 
  border: '1.5px solid #e91e63' 
};

const borderDesignStyle = {
  position: 'absolute',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  border: '1px solid #00AEEF',
  margin: '4px', // மெல்லிய இரட்டை பார்டர் தோற்றம் தரும்
  pointerEvents: 'none',
};

// படத்தின் மேல் வலதுபுறம் உள்ள அந்த சிறிய டிசைன் பாக்ஸ்
const cornerDecoration = {
  position: 'absolute',
  top: '0',
  right: '0',
  width: '100px',
  height: '30px',
  borderLeft: '2px solid #00AEEF',
  borderBottom: '2px solid #00AEEF',
  backgroundColor: '#fff',
  zIndex: '1',
};
const mergedCenterTop = { 
  gridColumn: 'span 2', 
  gridRow: 'span 1', 
  display: 'flex', 
  justifyContent: 'center', 
  alignItems: 'center' 
};

const mergedCenterBottom = { 
  gridColumn: 'span 2', 
  gridRow: 'span 1', 
  display: 'flex', 
  justifyContent: 'center', 
  alignItems: 'center',
  color: '#00AEEF', 
  fontWeight: 'bold', 
  fontSize: '11px' 
};

const deityStyle = { 
  width: '90px', 
  height: '40px', 
  objectFit: 'contain' 
};
const gridCell = { 
  border: '1px solid #e91e63', 
  display: 'flex', 
  alignItems: 'center', 
  justifyContent: 'center', 
  fontSize: '11px',       // எழுத்து அளவு குறைக்கப்பட்டுள்ளது
  fontWeight: 'bold',
  color: '#000',
  width: '45px',
  height: '45px',
  padding: '2px',         // உள் இடைவெளி
  lineHeight: '1.1',      // வரிகளுக்கு இடையிலான இடைவெளி குறைப்பு
  overflow: 'hidden'
};

const horoscopeSectionWrapper = { 
  display: 'flex', 
  justifyContent: 'center', // மையப்படுத்தப்பட்டது
  gap: '15px',              // கட்டங்களுக்கு இடையே இடைவெளி
  padding: '10px 45px', 
  alignItems: 'center',
  marginTop: '-10px'
};
const centerImageContainer = { 
  flex: 1, 
  display: 'flex', 
  justifyContent: 'center' 
};

const centerLogoStyle = { 
  width: '110px', 
  height: '110px', 
  objectFit: 'contain' 
};

// --- SUB-INFO BOXES (HOROSCOPE DETAILS) ---
const blueBoxContainer = { 
  display: 'flex', 
  margin: '10px 45px', 
  alignItems: 'center' 
};

const blueSubBox = { 
  flex: 1, 
 
  borderRadius: '8px', 
  padding: '6px' 
};

// --- FOOTER & DASA ---
const dasaRowStyle = { 
  color: '#00AEEF', 
  fontWeight: 'bold', 
  fontSize: '12px', 
  display: 'flex', 
  alignItems: 'baseline' 
};

const dasaInputLine = { 
  borderBottom: '1px dotted #00AEEF', 
  flex: 1, 
  margin: '0 8px' 
};

const smallInputLine = { 
  borderBottom: '1px dotted #000', 
  width: '30px', 
  textAlign: 'center', 
  margin: '0 5px' 
};

const termsContainerStyle = { 
  fontSize: '11px', 
  color: '#00AEEF', 
  textAlign: 'justify', 
  lineHeight: '1.4' 
};

const termsLabelStyle = { 
  color: '#e91e63', 
  fontWeight: 'bold' 
};

// --- INPUT FORM STYLES (SCREEN ONLY) ---
const formCardStyle = { 
  maxWidth: '1000px', 
  margin: '10px auto', 
  padding: '15px', 
  backgroundColor: '#fff', 
  borderRadius: '8px' 
};

const inputStyle = { 
  padding: '6px', 
  border: '1px solid #ccc', 
  borderRadius: '4px', 
  width: '100%',
  fontSize: '14px'
};

const btnStyle = { 
  marginTop: '10px', 
  width: '100%', 
  padding: '10px', 
  backgroundColor: '#e91e63', 
  color: '#fff', 
  border: 'none', 
  cursor: 'pointer', 
  fontWeight: 'bold' 
};
// --- ADD THESE TO YOUR STYLES SECTION TO FIX ERRORS ---

const horoInputStyle = { 
  padding: '6px', 
  border: '1px solid #ccc', 
  borderRadius: '4px', 
  width: '100%', 
  backgroundColor: '#e3f2fd', // Light blue background for horoscope inputs
  fontSize: '14px' 
};

const chartInputContainer = { 
  display: 'flex', 
  gap: '20px', 
  marginTop: '15px', 
  gridColumn: 'span 4' 
};

const dropdownGrid = { 
  display: 'grid', 
  gridTemplateColumns: 'repeat(6, 1fr)', 
  gap: '5px' 
};
export default Vaniyar;
